import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const ALERT_SEVERITY_COLORS = {
  error: { main: '#d32f2f', light: '#ef5350', lighter: '#fdecea' },
  success: { main: '#2e7d32', light: '#4caf50', lighter: '#edf7ed' },
  warning: { main: '#ed6c02', light: '#ff9800', lighter: '#fff4e5' },
  info: { main: '#0288d1', light: '#03a9f4', lighter: '#e5f6fd' },
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Alert(theme: Theme): unknown {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '4px !important',
        },
        standardError: {
          backgroundColor: ALERT_SEVERITY_COLORS.error.lighter,
          color: ALERT_SEVERITY_COLORS.error.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.error.main },
        },
        standardSuccess: {
          backgroundColor: ALERT_SEVERITY_COLORS.success.lighter,
          color: ALERT_SEVERITY_COLORS.success.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.success.main },
        },
        standardWarning: {
          backgroundColor: ALERT_SEVERITY_COLORS.warning.lighter,
          color: ALERT_SEVERITY_COLORS.warning.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.warning.main },
        },
        standardInfo: {
          backgroundColor: ALERT_SEVERITY_COLORS.info.lighter,
          color: ALERT_SEVERITY_COLORS.info.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.info.main },
        },
        filledError: {
          backgroundColor: '#FDEDED',
          color: '#5F2120',
          '& .MuiAlert-icon': { color: '#5F2120' },
          '& .MuiAlertTitle-root': { color: 'inherit' },
        },
        filledSuccess: {
          backgroundColor: '#EDF7ED',
          color: '#1E4620',
          '& .MuiAlert-icon': { color: 'inherit' },
          '& .MuiAlertTitle-root': { color: 'inherit' },
        },
        filledWarning: {
          backgroundColor: ALERT_SEVERITY_COLORS.warning.main,
          color: '#fff',
          '& .MuiAlert-icon': { color: '#fff' },
        },
        filledInfo: {
          backgroundColor: ALERT_SEVERITY_COLORS.info.main,
          color: '#fff',
          '& .MuiAlert-icon': { color: '#fff' },
        },
        outlinedError: {
          borderColor: ALERT_SEVERITY_COLORS.error.main,
          color: ALERT_SEVERITY_COLORS.error.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.error.main },
        },
        outlinedSuccess: {
          borderColor: ALERT_SEVERITY_COLORS.success.main,
          color: ALERT_SEVERITY_COLORS.success.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.success.main },
        },
        outlinedWarning: {
          borderColor: ALERT_SEVERITY_COLORS.warning.main,
          color: ALERT_SEVERITY_COLORS.warning.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.warning.main },
        },
        outlinedInfo: {
          borderColor: ALERT_SEVERITY_COLORS.info.main,
          color: ALERT_SEVERITY_COLORS.info.main,
          '& .MuiAlert-icon': { color: ALERT_SEVERITY_COLORS.info.main },
        },
      },
    },
  };
}
